angular.module('tgaAdmin').service('rootScopeCacheService', [
  '$rootScope',
  function ($rootScope) {
    function checkInitialized() {
      if (angular.isUndefined($rootScope.cache)) {
        $rootScope.cache = {};
      }
    }

    function set(key, value) {
      checkInitialized();
      $rootScope.cache[key] = value;
    }

    function get(key) {
      checkInitialized();
      return $rootScope.cache[key];
    }

    return {
      set,
      get,
    };
  },
]);
